
import Group from 'vux/src/components/group/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Selector from 'vux/src/components/selector/index.vue'

import { formatDate } from '@/plugin/format.js'
import PictureList from '@/components/PictureList.vue'

import UploadFile from '@/views/controls/uploadfile.vue'
export default {
name: 'home',
data() {
return {
filters: {
keyword: '',
status: 0
},
datas: [],
dclassifys: [],
dmodels: [],
menusVisible: false,
detailVisible: false,
pictureVisible: false,
canDeleteList: [],
picturelist: [],
isEdit: false,
dataForm: {
id: '',
usertype: null,
company: '',
address: '',
contact: '',
phone: '',
dtype: '显示器',
dclassify: '',
model: '',
warrantystatus: null,
seriesno: '',
invoice: null,
troubledescription: '',
annex: null
},
ucoptions: [
{
key: '经销商',
value: '经销商'
},
{
key: '直接用户',
value: '单位用户'
}
],
wscoptions: [
{
key: '保内',
value: '保内'
},
{
key: '保外',
value: '保外'
}
],
fixcontact: function(value) {
const reg = /^[\u4E00-\u9FA5]{1,4}(?:·[\u4E00-\u9FA5]{2,4})*$/
if (reg.test(value)) {
return { valid: true }
} else {
return { valid: false, msg: '请输入正确的姓名' }
}
},
fixphone: function(value) {
const reg = /0\d{2,3}-[1-9]\d{6,7}/
if (reg.test(value)) {
return { valid: true }
} else {
return { valid: false, msg: '请输入正确格式' }
}
},
options: {
getThumbBoundsFn(index) {
let thumbnail = document.querySelectorAll('.previewer-img')[index]
let pageYScroll =
window.pageYOffset || document.documentElement.scrollTop
let rect = thumbnail.getBoundingClientRect()
return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
}
}
}
},
filters: {
formatDate(time) {
if (time === null) {
return null
} else {
var date = new Date(time)
return formatDate(date, 'yyyy-MM-dd')
}
}
},
watch: {},
methods: {
getlist: function() {
let un = sessionStorage.getItem('user')
let params = {
UserName: un,
Keyword: this.filters.keyword.trim()
}
if (this.filters.status === 0) {
params.Status = '已报修'
} else if (this.filters.status === 1) {
params.Status = '已派工'
} else if (this.filters.status === 2) {
params.Status = '已处理'
}
let that = this
this.$api
.getRepair(params)
.then(res => {
if (res.Status === 1) {
that.datas = res.Entity
} else {
that.$vux.alert.show({
title: '错误',
content: res.Message
})
}
})
.catch(function(res) {
that.$vux.alert.show({
title: '错误',
content: '网络错误！'
})
})

this.dtypeSelectChanged()
},
handleAdd() {
this.detailVisible = true
this.dataForm = {
usertype: null,
company: '',
address: '',
contact: '',
phone: '',
dtype: '显示器',
dclassify: '',
model: '',
warrantystatus: null,
seriesno: '',
invoice: null,
troubledescription: '',
annex: null
}
this.isEdit = true
},
dtypeSelectChanged: function(selVal) {
let params = { DType: this.dataForm.dtype }

this.$api
.selectDClassify(params)
.then(res => {
if (res.Status === 1) {
this.dclassifys = res.Entity
if (this.dclassifys.indexOf(this.dataForm.dclassify) >= 0) {
} else {
this.dataForm.dclassify = ''
this.dataForm.model = ''
}
} else {
this.$alert(res.Message, '错误', {
confirmButtonText: '确定'
})
}
})
.catch(function(res) {
alert(res)
})
},
dclassifySelectChanged: function(selVal) {
let params = {
DClassify: this.dataForm.dclassify,
DType: this.dataForm.dtype
}
console.log(params)
let that = this
this.$api
.selectDModel(params)
.then(res => {
if (res.Status === 1) {
that.dmodels = res.Entity
var isMatch = false
res.Entity.forEach(en => {
if (en.DModel === that.dataForm.model) {
isMatch = true
}
})
if (!isMatch) {
that.dataForm.model = ''
}
} else {
that.$alert(res.Message, '错误', {
confirmButtonText: '确定'
})
}
})
.catch(function(res) {
alert(res)
})
},
handleEdit: function(dev) {
this.detailVisible = true
this.dataForm = {
id: dev.Id,
usertype: dev.UserType,
company: dev.Company,
address: dev.Address,
contact: dev.Contact,
phone: dev.Phone,
dtype: dev.DType,
dclassify: dev.DClassify,
model: dev.Model,
warrantystatus: dev.WarrantyStatus,
seriesno: dev.SeriesNO,
invoice: dev.Invoice,
troubledescription: dev.TroubleDescription,
annex: dev.Annex,
status: dev.Status
}
this.isEdit = true
},
handleOpen: function(dev) {
this.detailVisible = true
this.dataForm = {
id: dev.Id,
usertype: dev.UserType,
company: dev.Company,
address: dev.Address,
contact: dev.Contact,
phone: dev.Phone,
dtype: dev.DType,
dclassify: dev.DClassify,
model: dev.Model,
warrantystatus: dev.WarrantyStatus,
seriesno: dev.SeriesNO,
invoice: dev.Invoice,
troubledescription: dev.TroubleDescription,
annex: dev.Annex,
status: dev.Status
}
this.isEdit = false
},
handleConfirm: function() {
if (!this.dataForm.usertype) {
this.$vux.toast.text('请选择用户类别')
return
}
if (!this.dataForm.company) {
this.$vux.toast.text('请输入单位名称')
return
}
if (!this.dataForm.address) {
this.$vux.toast.text('请输入联系地址')
return
}
if (!this.dataForm.contact) {
this.$vux.toast.text('请输入联系人')
return
} else {
const reg = /^[\u4E00-\u9FA5]{1,4}(?:·[\u4E00-\u9FA5]{2,4})*$/
if (!reg.test(this.dataForm.contact)) {
this.$vux.toast.text('联系人请输入正确格式')
return
}
}

if (!this.dataForm.phone) {
this.$vux.toast.text('请输入联系电话')
return
} else {
const reg = /0\d{2,3}-[1-9]\d{6,7}/
if (!reg.test(this.dataForm.phone)) {
this.$vux.toast.text('联系电话请输入正确格式')
return
}
}
if (!this.dataForm.dclassify) {
this.$vux.toast.text('请选择设备分类')
return
}
if (!this.dataForm.model) {
this.$vux.toast.text('请选择型号')
return
}
if (!this.dataForm.warrantystatus) {
this.$vux.toast.text('请选择保修状况')
return
}
if (!this.dataForm.invoice) {
this.$vux.toast.text('请上传铭牌及发票')
return
}
if (!this.dataForm.troubledescription) {
this.$vux.toast.text('请输入故障描述')
return
} else {
if (
this.dataForm.troubledescription.length < 10 ||
this.dataForm.troubledescription.length > 200
) {
this.$vux.toast.text('故障描述在10到200个字符')
return
}
}
if (!this.dataForm.annex) {
this.$vux.toast.text('请上传相关图片')
return
}

let that = this
this.$vux.confirm.show({
title: '提示',
content: '确认提交吗？',
onConfirm() {
let un = sessionStorage.getItem('user')
let params = {
UserName: un,
UserType: that.dataForm.usertype,
Company: that.dataForm.company,
Address: that.dataForm.address,
Contact: that.dataForm.contact,
Phone: that.dataForm.phone,
DType: that.dataForm.dtype,
DClassify: that.dataForm.dclassify,
Model: that.dataForm.model,
WarrantyStatus: that.dataForm.warrantystatus,
SeriesNO: that.dataForm.seriesno,
Invoice: that.dataForm.invoice,
TroubleDescription: that.dataForm.troubledescription,
Annex: that.dataForm.annex,

Status: that.dataForm.status
}
if (that.dataForm.id !== '') params.Id = that.dataForm.id
that.$api
.saveRepair(params)
.then(res => {
if (res.Status === 1) {
that.$vux.alert.show({
title: '提示',
content: '提交成功'
})

that.detailVisible = false
that.getlist()
} else {
that.$vux.alert.show({
title: '错误',
content: res.Message
})
}
})
.catch(function(res) {
that.$vux.alert.show({
title: '错误',
content: '网络错误！'
})
})
}
})
},
handleDelete: function(device) {
this.canDeleteList = []
this.canDeleteList.push(device)
this.handleDeleteList()
},
handleDeleteList: function() {
let that = this
this.$vux.confirm.show({
title: '提示',
content:
'确认删除' +
that.canDeleteList.length.toString() +
'台设备进行报修吗？',
onConfirm() {
let ids = []
that.canDeleteList.forEach(pt => {
ids.push(pt.Id)
})
that.$api
.deleteRepair(ids)
.then(res => {
if (res.Status === 1) {
that.$vux.alert.show({
content: '设备删除成功',
title: '提示'
})
that.getlist()
} else {
that.$vux.alert.show({
title: '错误',
content: res.Message.replace(/\n\r/g, '</br>')
})
}
})
.catch(function(res) {
that.$vux.alert.show({
title: '错误',
content: '网络错误！'
})
})
}
})
},

handleShowPicture: function(params) {
this.pictureVisible = true

let that = this
this.$api
.getFile(params)
.then(res => {
if (res.Status === 1) {
var list = []
res.Entity.forEach(item => {
list.push({
src: 'data:image/png;base64,' + item.Contents,
msrc: 'data:image/png;base64,' + item.Contents
})
})
that.picturelist = list
} else {
that.$vux.alert.show({
title: '错误',
content: res.Message
})
}
})
.catch(function(res) {
that.$vux.alert.show({
title: '错误',
content: '网络错误！'
})
})
},
show(index) {
this.$refs.previewer.show(index)
},
logout: function() {
var that = this
this.$vux.confirm.show({
title: '提示',
content: '确认退出?',
onConfirm() {
sessionStorage.removeItem('user')
that.$router.push('/mobile/login')
}
})
},
handlePreview: function() {},
handleRemove: function() {}
},
created() {
window.document.title = '产品报修'
this.getlist()
},
directives: {
TransferDom
},
components: {
Group,
Flexbox,
FlexboxItem,
XButton,
Divider,
XHeader,
Scroller,
CheckIcon,
Popup,
Datetime,
Confirm,
Cell,
XInput,
Radio,
PictureList,
Previewer,
ButtonTab,
Search,
ButtonTabItem,
XTextarea,
PopupRadio,
Selector,
UploadFile
}
}



// WEBPACK FOOTER //
// ./src/mobile/repairhome.vue